import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
	SHIPPING_TYPE,
	FORM_FIELDS,
} from '../../../constants'
import { SelectButton } from 'primereact/selectbutton'
import LooseItemForm from './SubSections/LooseItemForm'
import ULDItemForm from './SubSections/ULDItemForm'
import Popup from '../../Popup/Popup'
import closeIcon from '../../../assets/images/icon-close-alert.png'
import { useTranslation } from 'react-i18next'
import MESSAGES from '../../../constants/Messages'
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import RadioToggle from '../../SearchPanel/RadioToggle'
import CommonInput from '../../../common/Resusable/CommonInput'
import { CustomPopup } from '../../../common/Popup/CustomPopup'

const AdditionalCargoDetails = ({
	awbDetails,
	setAwbDetails,
	isAllStackable,
	setAllStackable,
	isAllTiltable,
	setAllTiltable,
	handleAddLineItem,
	error,
	setError,
	setCalculatedTotalWeight,
	setActualTotalIneItemWeight,
	setTotalPivoteWeightInKg,
	totalPivoteWeightInKg,
	showDetails,
	setShowDetails,
	setNotificationMessage,
	setNotificationType,
	handleWeightChange,
	isBupSccPresent,
	shippingTypeError,
	setShippingTypeError
}) => {

	const { t, i18n } = useTranslation(['labels', 'errors'])

	const SHIPPING_TYPE_SELECT_ITEMS = [
		{ label: t('COMMON.LOOSE'), value: SHIPPING_TYPE.LOOSE },
		{ label: t('COMMON.ULD'), value: SHIPPING_TYPE.ULD },
	]

	const history = useHistory()
	//const [shippingType, setShippingType] = useState(SHIPPING_TYPE.LOOSE)
	let { ULDDetails, mixLooseDetails, looseDetails } = awbDetails
	let shippingType = awbDetails.shippingType
	const [popupDetails, setPopupDetails] = useState(null)

	useEffect(() => {}, [history])

	useEffect(() => {}, [])

	const handleShowDetails = () => {
		setShowDetails(!showDetails)
	}

	const checkChanges = (selectedCargoType) => {
		let findChanges = 0
		if (selectedCargoType) {
			if (selectedCargoType == SHIPPING_TYPE.ULD) {
				looseDetails.some((item) => {
					Object.keys(item).some(function (k) {
						if (item[k] && k === 'pieces') {
							showTabPopup(selectedCargoType)
							findChanges++
						}
					})
				})
			} else {
				ULDDetails.some((item) => {
					Object.keys(item).some(function (k) {
						if (item[k] && k === 'pieces') {
							showTabPopup(selectedCargoType)
							findChanges++
						}
					})
				})
				mixLooseDetails.some((item) => {
					Object.keys(item).some(function (k) {
						if (item[k] && k === 'pieces') {
							showTabPopup(selectedCargoType)
							findChanges++
						}
					})
				})
			}
		}
		if (findChanges > 0) {
			return true
		} else {
			return false
		}
	}

	const setShippingType = (val) => {
		setAwbDetails((prevState) => ({
			...prevState,
			shippingType: val,
		}))
	}

	const showTabPopup = (selectedCargoType) => {
		const header = t('COMMON.CONFIRM')
		const message =
			shippingType && SHIPPING_TYPE.LOOSE === shippingType
				? t(MESSAGES.BKG_TAB_MESSAGE_LOOSE, { ns: 'errors' })
				: t(MESSAGES.BKG_TAB_MESSAGE_ULD, { ns: 'errors' })
		const primaryBtnLbl = t('COMMON.OK')
		const acceptFn = () => {
			onTabOkclick(selectedCargoType)
		}
		const secondaryBtnLbl = t('COMMON.CANCEL')
		const rejectFn = () => {
			onTabCancelclick()
		}
		setPopupDetails({
			display: true,
			header: header,
			message: message,
			primaryBtnLbl: primaryBtnLbl,
			acceptFn: acceptFn,
			secondaryBtnLbl: secondaryBtnLbl,
			rejectFn: rejectFn,
		})
	}

	const onTabOkclick = (selectedCargoType) => {
		closeErrorPopup()
		setShippingType(selectedCargoType)
	}
	const onTabCancelclick = () => {
		closeErrorPopup()
	}

	const closeErrorPopup = () => {
		setPopupDetails(null)
	}

	useEffect(() => {
		if (isBupSccPresent && shippingType !== SHIPPING_TYPE.ULD) {
			setShippingType(SHIPPING_TYPE.ULD);
		}
	}, [isBupSccPresent]);

	return (
		<div className='portal-row cutom-details show-additional-details-row'>
			<div className='portal-col'>
				{!showDetails && (
					<div className='justify-content-center'>
						<div className='col-12 d-flex additional-btn-box justify-content-center'>
							<SecondaryButton
								label={t('CAPTURE_AWB.SHOW_ADD_CARGO_DTLS')}
								onClick={handleShowDetails}
							/>
						</div>
					</div>
				)}
				{showDetails && (
					// <div className='mt-md-2 mt-0'>
						
						<div className='cargo-details'>
							<div className='additional-cargo-details-row'>
								{/* <div className='d-flex align-items-center'> */}
									<label
										className='section-sub-heading cargo-details-heading mb-0'
									>
										{t('CAPTURE_AWB.ADD_CARGO_DTLS')}
									</label>
								{/* </div> */}
								<div className=''>
									{/* Desktop: Show "Hide Additional cargo details" */}
									<button
										type="button"
										className="cargo-details-hide-btn p-0 d-none d-lg-block"
										onClick={handleShowDetails}
									>
										{t('CAPTURE_AWB.HIDE_CARGO_DTLS')}
									</button>
									{/* Mobile: Show "Remove" */}
									<button
										type="button"
										className="btn cargo-details-hide-btn-mob p-0 d-block d-lg-none"
										onClick={handleShowDetails}
									>
										{t('COMMON.REMOVE')}
									</button>
								</div>
							</div>

							{/* <div className='form-row'>
								<div className='col-12 col-lg-4'>
									<label className='form-item__label'>
										{t('COMMON.CARGO')}
									</label>
									<SelectButton
										className='custom-select-button shipping-type'
										id='loose-portal'
										value={shippingType}
										options={SHIPPING_TYPE_SELECT_ITEMS}
										onChange={(e) => {
											if (e.value && !checkChanges(e.value)) {
												setShippingType(e.value)
												setError((prevState) => ({
													...prevState,
													[FORM_FIELDS.LOOSE_ITEMS]: null,
												}))
											}
										}}
									></SelectButton>
								</div>
							</div> */}

							{/* <div className='form-row'> */}
								<div className='loose-uld-container'>
									<label className='cargo-label mb-0'>
										{t('BOOKING.CARGO_LABEL')}
									</label>
									<div className="cargo-looseuld-row">
										<RadioToggle
											checkedArray={[
												shippingType === SHIPPING_TYPE.LOOSE,
												shippingType === SHIPPING_TYPE.ULD
											]}
											valueArray={[SHIPPING_TYPE.LOOSE, SHIPPING_TYPE.ULD]}
											labelArray={[
												t('COMMON.LOOSE'),
												t('COMMON.ULD')
											]}
											className='shipping-type-toggle'
									        onChangeArray={[
										        () => {
											    if (isBupSccPresent) {
												// Find BUP SCC code and description
												const allSccs = [
													...(awbDetails.shipmentSccs || []),
													...(awbDetails.appliedSccs || []),
													...(awbDetails.additionalSccs || []),
													...(awbDetails.appliedServices || [])
												];
												const bupSccObj = allSccs.find(item => item.scc === 'BUP');
												const bupSccCode = bupSccObj ? bupSccObj.scc : 'BUP';

												setShippingTypeError(`Selected SCC (${bupSccCode}) does not allow Loose booking.`);
												setTimeout(() => setShippingTypeError(''), 5000);
												setShippingType(SHIPPING_TYPE.ULD);
												return;
											}
											if (!checkChanges(SHIPPING_TYPE.LOOSE)) {
												setShippingType(SHIPPING_TYPE.LOOSE);
												setError((prevState) => ({
													...prevState,
													[FORM_FIELDS.LOOSE_ITEMS]: null,
												}));
											  }
										    },
										       () => {
											      setShippingType(SHIPPING_TYPE.ULD);
											      setError((prevState) => ({
												...prevState,
												[FORM_FIELDS.LOOSE_ITEMS]: null,
											}));
										}
									]}
											// onChangeArray={[
											// 	() => {
											// 		if (!checkChanges(SHIPPING_TYPE.LOOSE)) {
											// 			setShippingType(SHIPPING_TYPE.LOOSE);
											// 			setError((prevState) => ({
											// 				...prevState,
											// 				[FORM_FIELDS.LOOSE_ITEMS]: null,
											// 			}));
											// 		}
											// 	},
											// 	() => {
											// 		if (!checkChanges(SHIPPING_TYPE.ULD)) {
											// 			setShippingType(SHIPPING_TYPE.ULD);
											// 			setError((prevState) => ({
											// 				...prevState,
											// 				[FORM_FIELDS.LOOSE_ITEMS]: null,
											// 			}));
											// 		}
											// 	}
											// ]}
										/>
									</div>
								</div>
							{/* </div> */}
							{/* <div className=''> */}
								<div className=''>
									{shippingType === 'LOOSE' ? (
										<LooseItemForm
											awbDetails={awbDetails}
											setAwbDetails={setAwbDetails}
											isAllStackable={isAllStackable}
											setAllStackable={setAllStackable}
											isAllTiltable={isAllTiltable}
											setAllTiltable={setAllTiltable}
											handleAddLineItem={handleAddLineItem}
											setActualTotalIneItemWeight={setActualTotalIneItemWeight}
											setCalculatedTotalWeight={setCalculatedTotalWeight}
											setError={setError}
											error={error}
											totalWeightInKilo={awbDetails.totalWeightInKg}
											handleWeightChange={handleWeightChange}
										/>
									) : (
										<ULDItemForm
											handleAddLineItem={handleAddLineItem}
											totalWeightInKilo={awbDetails.totalWeightInKg}
											setTotalPivoteWeightInKg={setTotalPivoteWeightInKg}
											totalPivoteWeightInKg={totalPivoteWeightInKg}
											error={error}
											setError={setError}
											setActualTotalIneItemWeight={setActualTotalIneItemWeight}
											awbDetails={awbDetails}
											setAwbDetails={setAwbDetails}
											setNotificationMessage={setNotificationMessage}
											setNotificationType={setNotificationType}
										/>
									)}
								</div>
							{/* </div> */}
							<div id='promo-code' className='shipping-deparr-row promo-div-awb'>
								<div
									className={`form-group`}
								>
									<CommonInput
										type='text'
										label={t('BOOKING.PROMO_CODE')}
										value={awbDetails.promoCode ? awbDetails.promoCode.toUpperCase() : ''}
										onChange={({ target }) => {
											if (!target) return
											setAwbDetails((prevState) => ({
												...prevState,
												promoCode: target.value.toUpperCase(),
											}))
										}}
									/>
								</div>

								{/* <div className='col-12 col-lg-3 form-item form-item--text'>
									<label className='form-item__label'>
										{t('BOOKING.PROMO_CODE')}
									</label>
									<input 
										type='text' 
										className='form-item__field'									
										value={awbDetails.promoCode ? awbDetails.promoCode.toUpperCase() : ''}
										onChange={({ target }) => {	
											if (!target) return											
											setAwbDetails((prevState) => ({
												...prevState,
												promoCode: target.value.toUpperCase(),
											}))
										}}
									 />
								</div> */}
							</div>
							{popupDetails && popupDetails.display && (

								<CustomPopup
									footerPriBtnLabel={popupDetails.primaryBtnLbl}
									footerSecBtnLabel={popupDetails.secondaryBtnLbl}
									footerPriBtnClick={popupDetails.acceptFn}
									footerSecBtnClick={popupDetails.rejectFn}
									headerComponent={{ mainHeader: popupDetails.header }}
									body={<p>{popupDetails.message}
										</p>}
									onClose={closeErrorPopup}
									isVisible={popupDetails.display}
								/>

								// <Popup
								// 	display={popupDetails.display}
								// 	header={popupDetails.header}
								// 	message={popupDetails.message}
								// 	primaryBtnLbl={popupDetails.primaryBtnLbl}
								// 	acceptFn={popupDetails.acceptFn}
								// 	secondaryBtnLbl={popupDetails.secondaryBtnLbl}
								// 	rejectFn={popupDetails.rejectFn}
								// 	closeErrorPopup={closeErrorPopup}
								// />
							)}
						</div>
					// </div>
				)}
			</div>
		</div>
	)
}

export default AdditionalCargoDetails
